// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1RdIN","buttons":"PendingPaymentAlert_buttons__NqmFY"};